import * as React from 'react';
import CollapsingWrapper from '../../../shared/components/CollapsingWrapper/CollapsingWrapper';
import {TooltipIconProps} from '@material-ui/core/TooltipIcon';

export interface FormSectionProps {
  key: React.Key; // key is required
  onToggleOpen?(open): void;
  open?: boolean;
  title: React.ReactNode;
  tooltip?: TooltipIconProps['title'];
  disabled?: boolean;
  id?: string;
  stickyTitle?: boolean;
}

const FormSection: React.FunctionComponent<FormSectionProps> = ({stickyTitle = true, ...props}: FormSectionProps) => {
  return <CollapsingWrapper stickyTitle={stickyTitle} {...props} />;
};

export default FormSection;
